<template>
  <div>
    <rhcn-card-v2 :title="$t('message.refuse.klarnaRebutDrawer.appealReply.title')">
      <template #body>
        <el-form :disabled="disabled" :rules="rules()" :model="formData" ref="appealForm">
          <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.appealReply.appealExplain')" prop="appealExplain">
            <el-input :placeholder="$t('message.refuse.klarnaRebutDrawer.appealReply.placeholder')" type="textarea" show-word-limit maxlength="2000" v-model="formData.appealExplain"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </rhcn-card-v2>
  </div>
</template>

<script>
import RhcnCardV2 from '@/componentsV2/base-cmps/card/index.vue';

import { rules } from './rules';
export default {
  components: {
    RhcnCardV2,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    rules,
    validate() {
      return this.$refs.appealForm.validate();
    },
    clearValidate() {
      this.$refs.appealForm.clearValidate();
    },
  },
  computed: {
    formData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit('update:data', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

:deep(.el-input__count) {
  background-color: transparent !important;
  color: #8D98AF !important;
}

:deep(.el-descriptions__body) {
  background-color: transparent !important;
}
</style>
